import ListaCategorias from '../componentes/ListaCategorias'
import ListaSubcategorias from '../componentes/ListaSubcategorias'
import LinksCategoria from '../componentes/LinksCategoria'

const routes = [
  ...route('/categorias', ListaCategorias, {
    auth: true,
    require_admin: true,
  }),
  ...route('/sub-categorias/:id', ListaSubcategorias, {
    auth: true,
    require_admin: true,
  }),
]

function route(path, component = Default, meta = {}, props = true) {
  return [{
    path,
    component,
    meta,
    props
  }]
}

export default routes